import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import Topbar from '../layout/Topbar';
import { useBookStore } from '../../provider/BookStore';
import { useTransactionStore } from '../../provider/TransactionStore';
import { useMasterStore } from '../../provider/MasterStore';
import dayjs from '../../utils/dayjs';
import { getErrorMessage, logError } from '../../utils/errorHandler';

const AddTransaction = () => {
  const location = useLocation();
  const bookState = useBookStore();
  const book = bookState.book;
  // untuk membuang cache transaksi setelah data berubah
  const transStore = useTransactionStore();
  // cache master data (kategori & dompet)
  const masterStore = useMasterStore();
  const transaction = location.state?.transaction;
  const action = location.state?.action;
  const type = location.state?.type;
  const navigate = useNavigate();

  const [msg, setMsg] = useState('');
  const [debitCategories, setDebitCategories] = useState([]);
  const [kreditCategories, setKreditCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pockets, setPockets] = useState([]);
  const [title, setTitle] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [pocketId, setPocketId] = useState('');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('00:00');
  const [selectedType, setSelectedType] = useState('kredit');

  // Initialize all input of date type.
  // const calendars = bulmaCalendar.attach('[type="date"]');

  useEffect(() => {
    // setBookId(location.state.bookId);
    if (book.id === undefined) {
      navigate('/')
    }
    getCategories();
    getPockets();
    console.log(transaction)

    if (action === 'edit') {
      setSelectedType(transaction.type);
      setTitle(transaction.note);
      setAmount(transaction.amount);
      setDate(transaction.date);
      setTime(transaction.time);
      setCategoryId(transaction.category_id);
      setPocketId(transaction.pocket_id);
    } else {
      const date = dayjs();
      setDate(date.format('YYYY-MM-DD'));
      setTime(date.format('HH:mm'));
    }
  }, []);

  const getCategories = async (e) => {
    try {

      // via cache store: instan bila cache segar, tetap tampil instan
      // bila basi (sambil revalidate di background)
      const cats = await masterStore.loadCategories(book.id);
      if (!cats) return;
      setDebitCategories(cats.debit);
      setKreditCategories(cats.kredit);
      if (type === 'debit') {
        setCategories(cats.debit)
      } else {
        setCategories(cats.kredit)
      }

    } catch (error) {
      // jangan senyapkan error: sebelumnya catch kosong membuat list kategori
      // hilang tanpa jejak (mis. saat request 401 ditolak interceptor)
      console.error('Gagal memuat kategori:', error?.response || error?.message);
      setMsg('Gagal memuat kategori, coba buka ulang halaman ini.');
    }

  }

  const getPockets = async () => {
    try {
      const poc = await masterStore.loadPockets(book.id);
      if (poc) setPockets(poc);
    } catch (error) {
      // jangan senyapkan error: sebelumnya catch kosong membuat list dompet
      // hilang tanpa jejak (mis. saat request 401 ditolak interceptor)
      console.error('Gagal memuat dompet:', error?.response || error?.message);
      setMsg('Gagal memuat dompet, coba buka ulang halaman ini.');
    }
  }

  const setType = (type) => {
    setSelectedType(type);
    if (type === 'debit') {
      setCategories(debitCategories);
    } else {
      setCategories(kreditCategories);
    }
  }

  const createTransaction = async (e) => {
    e.preventDefault()

    try {
      if (action === 'edit') {
        await api.post('/transaction/save', {
          transaction_id: transaction.id,
          book_id: book.id,
          pocket_id: pocketId,
          category_id: categoryId,
          type: selectedType,
          note: title,
          amount: amount,
          date: date,
          time: time,
        });
      } else {
        await api.post('/transaction/add', {
          book_id: book.id,
          pocket_id: pocketId,
          category_id: categoryId,
          type: selectedType,
          note: title,
          amount: amount,
          date: date,
          time: time,
        });
      }

      // data sudah berubah di server -> buang cache buku ini agar
      // halaman Transaksi & Statistik mengambil data terbaru
      transStore.invalidate(book.id);

      navigate('/transactions', { state: { book: book } })

    } catch (error) {
      logError('Gagal menyimpan transaksi:', error);
      setMsg(getErrorMessage(error, 'Gagal menyimpan transaksi. Silakan coba lagi.'))
    }
  }

  return (
    <div>
      <Topbar
        title={action === 'edit' ? 'Edit Transaksi' : 'Tambah Transaksi'}
        back={() => navigate('/transactions')}
      />
      <div className='container p-5'>
        <div className="columns is-centered">
          <div className="column is-5-widescreen is-6-desktop is-7-tablet">

            <p className='is-size-6 mb-4 ml-4'>Buku Kas : {book.title}</p>

            <div>
              <div onSubmit={createTransaction} className="card">
                <div className='card-content'>


                  <p className="has-text-centered">{msg}</p>

                  <div className="field mt-5">
                    {/* <label className="label">Keterangan</label> */}
                    <div className="control">
                      <label className='radio'>
                        <input type="radio" name='type' className='mr-2' checked={selectedType === 'debit'}
                          value='debit' onChange={(e) => setType(e.target.value)} />
                        Debit
                      </label>
                      <label className='radio'>
                        <input type="radio" name='type' className='mr-2 ml-4' checked={selectedType === 'kredit'}
                          value='kredit' onChange={(e) => setType(e.target.value)} />
                        Kredit
                      </label>
                    </div>
                  </div>
                  <div className="field mt-5">
                    <label className="label">Sejumlah (Rp.)</label>
                    <div className="controls">
                      <input type="text" className="input" placeholder='1000'
                        value={amount} onChange={(e) => setAmount(e.target.value)} />
                    </div>
                  </div>
                  <div className="field mt-5">
                    <label className="label">Keterangan</label>
                    <div className="controls">
                      <input type="text" className="input" placeholder='Keterangan'
                        value={title} onChange={(e) => setTitle(e.target.value)} />
                    </div>
                  </div>
                  <div className="field mt-5">
                    <div className='columns is-mobile'>
                      <div className='column'>
                        <label className="label">Tanggal</label>
                        <div className="controls">
                          <input type="date" className="input" placeholder='Tanggal'
                            value={date} onChange={(e) => setDate(e.target.value)} />
                        </div>
                      </div>
                      <div className='column is-two-fifths'>
                        <label className="label">Waktu</label>
                        <div className="controls">
                          <input type="time" className="input" placeholder='Tanggal'
                            value={time} onChange={(e) => setTime(e.target.value)} />
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="field mt-5">
                    <label className="label">Kategori</label>
                    <div className="select is-fullwidth">
                      <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
                        <option>-</option>
                        {categories.map((item, index) => (
                          <option key={index} value={item.id}>{item.title}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="field mt-5">
                    <label className="label">Dompet</label>
                    <div className="select is-fullwidth">
                      <select value={pocketId} onChange={(e) => setPocketId(e.target.value)}>
                        <option></option>
                        {pockets.map((item, index) => (
                          <option key={index} value={item.id}>{item.title}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <footer className="card-footer has-background-primary-30">
                  <button className="card-footer-item has-text-weight-bold has-text-white"
                    onClick={createTransaction}>
                    Simpan
                  </button>
                </footer>

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  )
}

export default AddTransaction
